import { useState } from "react";

import { SOURCE } from "@/constants";
import { useEpisode } from "@/containers/Episode/context";
import { PlayIcon } from "@/Icons";
import { cx } from "@/utils";
import Clickable from "@components/Clickable";

import Fallback from "./Fallback";

import styles from "../Cover.module.css";

const YoutubeCover = ({ episode }) => {
  const { cover } = episode;
  const [imgLoadFailed, setImgLoadFailed] = useState(false);
  const [coverLoaded, setCoverLoaded] = useState(false);

  const { setMediaModalOpen } = useEpisode();

  return imgLoadFailed || !cover ? (
    <Fallback source={SOURCE.YOUTUBE} />
  ) : (
    <>
      <img
        loading="lazy"
        src={cover}
        className={cx(styles.img, { [styles.visible]: coverLoaded })}
        onLoad={() => setCoverLoaded(true)}
        onError={() => setImgLoadFailed(true)}
        alt=""
      />

      <Clickable
        data-testid="youtube-embed-open"
        className={styles.play}
        onClick={() => setMediaModalOpen(true)}
      >
        <PlayIcon fill="currentColor" />
      </Clickable>
    </>
  );
};
export default YoutubeCover;
